import React from 'react';
import R from 'ramda';
import PropTypes from 'prop-types';
import ProductSwatchColours from '@cotyorg/ccx-organism-product-swatch/components/ProductSwatchColours';
import ProductSwatchDropdown from '@cotyorg/ccx-organism-product-swatch/components/ProductSwatchDropdown';
import { trackSelectedShadeEvent } from '@cotyorg/ccx-utils/js/tracking/adobe-dtm/events/product';
import { updateQueryStringWithoutReload } from './helpers';

const ProductSelection = ({ productDetails, subcategoryTitle }) => (
  <div className="product-selection">
    <ProductSwatchColours
      label={R.prop('shadeSelectLabel', productDetails)}
      separator="/ "
      labelFirst
      nameFirst
      onChange={({ shade, sku }) => {
        updateQueryStringWithoutReload({ shade });

        trackSelectedShadeEvent({
          shade: R.toLower(shade),
          sku,
          name: R.compose(R.toLower(), R.prop('title'))(productDetails),
          type: R.toLower(subcategoryTitle),
          location: 'radio button',
        });
      }}
    />

    <div className="product-selection__swatch-dropdown">
      <ProductSwatchDropdown
        label={R.prop('shadeSelectLabel', productDetails)}
        separator="/ "
        labelFirst
        nameFirst
        chevronIconSrc="/ccx-files/assets/chevron-down.svg"
        onChange={({ shade, sku }) => {
          trackSelectedShadeEvent({
            shade: R.toLower(shade),
            sku,
            name: R.compose(R.toLower(), R.prop('title'))(productDetails),
            type: R.toLower(subcategoryTitle),
          });
        }}
      />
    </div>
  </div>
);

ProductSelection.propTypes = {
  productDetails: PropTypes.shape({
    averageRating: PropTypes.any,
    benefits: PropTypes.arrayOf(PropTypes.object),
    buyButtonLabel: PropTypes.string,
    bvid: PropTypes.string,
    description: PropTypes.string,
    howToSteps: PropTypes.arrayOf(PropTypes.object),
    showIngredients: PropTypes.string,
    hideIngredients: PropTypes.string,
    longDescription: PropTypes.string,
    outOfStockLabel: PropTypes.string,
    priceRetailersPluralLabel: PropTypes.string,
    priceRetailersSingularLabel: PropTypes.string,
    retailersNotFoundLabel: PropTypes.string,
    shadeSelectLabel: PropTypes.string,
    title: PropTypes.string,
  }),
  subcategoryTitle: PropTypes.string,
};

export default ProductSelection;
